import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceOrderById } from '@/api/financial-center'
import * as math from 'mathjs'

@Component({})
export default class OrderInfo extends Vue {
    orderId: number = undefined
    logShow = true
    infoData: any = {}
    status = ''
    orderType = ''
    isUpdatedData = ''
    isShow = ''
    activities = []
    loading = false

    get thisRatioPrice() {
        let num = math.divide(math.bignumber(this.infoData.priceOrRatio), 100)
        return math.number(math.multiply(math.bignumber(this.infoData.price), num))
    }

    created() {
        this.orderId = Number(this.$route.query.id)
        this.status = this.$route.query.status as string
        this.isShow = this.$route.query.isShow as string
        this.orderType = this.$route.query.orderType as string || ''
        this.isUpdatedData = this.$route.query.isUpdatedData as string || '0'
        this.getInfoData()
    }

    menuBtn = menuBtn
    formatDate = formatDate

    async getInfoData() {
        this.loading = true
        await getFinanceOrderById({ id: this.orderId, isUpdatedData: this.isUpdatedData }).then((data: any)=>{
            this.infoData = data.financeOrder
            //    审批流程
            this.activities = data.financeOrder.messageReviewList
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    clickEditButton() {
        if(this.status === '审批中') {
            this.$message.error('审批中的项目不可编辑')
            return
        }
        this.$router.push({
            path: 'newOrdinaryOrder',
            query: {
                orderId: String(this.orderId),
                isUpdatedData: this.isShow == '1' ? '1' : this.isUpdatedData // 如果是已通过的订单 ，查看还是原来的，编辑传值查询最新的数据
            }
        })
    }

    handleClickEgistrationForm() {
        this.downFile(this.infoData.egistrationForm,  this.infoData.customerName)
    }

    // 下载文件，自定义文件名称
    downFile(url, fileName) {
        const x = new XMLHttpRequest()
        x.open('GET', url, true)
        x.responseType = 'blob'
        x.onload = function() {
            const url = window.URL.createObjectURL(x.response)
            const a = document.createElement('a')
            a.href = url
            a.download = fileName
            a.click()
        }
        x.send()
    }
}
